module.exports = __webpack_public_path__ + "assets/img/kv-5c4ec82b.jpg";